import React from 'react';
import Loader from '../../../assets/loader/Loader';
 
type Header = {
  label: string;
  size?: string;
};
 
type TableProps = {
  headers: Header[];
  rows: React.ReactNode[][];
  isPageLoading: boolean;
  allocatedStaff?: { [key: number]: number };
  isEditMode?: boolean;
  tableBg: string;
  isEdit?: boolean;
};
 
const Table: React.FC<TableProps> = ({
  headers,
  rows,
  isPageLoading,
  tableBg,
}) => {
  return (
    <div>
      <table className="min-w-full border-collapse border border-customBorder-tableBorder shadow-lg">
        <thead className="bg-backgroundColor-buttonCommonColor text-white">
          <tr className="text-sm">
            {headers.map((header, index) => (
              <th
                key={index}
                className="border border-customBorder-tableBorder p-3 text-sm text-left"
              >
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={`${tableBg}`}>
          {isPageLoading ? (
            <tr>
              <td
                colSpan={headers.length}
                className="text-center p-4 h-[200px] text-lg font-semibold text-text-textBlackColor"
              >
                <div className="inline-grid">
                  <Loader width={50} height={50} />
                </div>
              </td>
            </tr>
          ) : rows.length === 0 ? (
            <tr>
              <td
                colSpan={headers.length}
                className="text-center p-4 text-text-lightGray"
              >
                No data available
              </td>
            </tr>
          ) : (
            rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="text-sm text-left align-top">
                {row.map((cell, cellIndex) => {
                  if (React.isValidElement(cell)) {
                    const existingClass = cell.props.className || '';
                    return (
                      <td
                        key={cellIndex}
                        className="border border-customBorder-tableBorder p-3 whitespace-pre-wrap max-w-xs  text-text-textBlackColor"
                      >
                        {React.cloneElement<any>(cell, {
                          className: `${existingClass} w-full px-2 py-1`,
                        })}
                      </td>
                    );
                  } else {
                    // Render as plain text
                    return (
                      <td
                        key={cellIndex}
                        className="border border-customBorder-tableBorder p-3 whitespace-pre-wrap max-w-xs text-text-secondary" 
                      >
                        {cell}
                      </td>
                    );
                  }
                })}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
 
export default Table;